import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  Typography,
  Grid,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Iconify from '../../../../iconify';
const { PRIVATE_ROUTE } = API_ROUTES;

export default function PaymentTermList() {
  const [open, setOpen] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();

  const navigate = useNavigate();


  const getUserdata = (query) => {
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;
    let search_query = query.searchQuery ? query.searchQuery : '';
    let sortField = query?.sortField ? query?.sortField : sortEnable.sortField;
    let sortOrder = query?.sortOrder ? query?.sortOrder : sortEnable.sortOrder;
    if (typeof query !== 'string') {
      sort_params = `&sortField=${sortField}&sortOrder=${sortOrder}&search=${search_query}`;
    } else {
      sort_params = `&search=${query}`;
    }

    let isMounted = true;
    const getUsers = async () => {
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_PAYMENTTERM}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}`
      );

      if (isMounted) {
        setUsers(
          data.data?.map((item, index) => {
            return {
              _id: item._id,
              name: item.name,
              remark: item.remark,
            };
          })
        );
        setCount(data.total);
        setLoading(false);
      }
    };

    getUsers().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  };

  const columns = [
    {
      name: 'name',
      label: 'Name',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'remark',
      label: 'Remarks',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: '_id',
      label: '_id',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: '',
      lable: 'Action',
      options: {
        filter: true,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              <EditIcon onClick={(e) => handleEditRedirect(e, tableMeta.rowData[2])} />
              <DeleteIcon onClick={(e) => handleRowDelete(e, tableMeta.rowData[2])} />
            </div>
          );
        },
      },
    },
  ];
  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    print: true,
    filter: false,
    fixedHeader: true,
    count: count,
    searchOpen: true,
    selectableRows: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15) 200, 208,0.15)' : 'white',
        },
      };
    },
    setTableProps: () => {
      return {
        padding: 'default',
        border: '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15)',
        size: 'small',
      };
    },
    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);
      if (searchQuery !== null && searchQuery.length > 2) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.sortField; 
          const sortOrder = sortEnable.sortOrder; 
          getUserdata({ sortField, sortOrder, searchQuery });
        } else {
          getUserdata(searchQuery);
        }
        setLoading(true);
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.sortField; 
          const sortOrder = sortEnable.sortOrder; 
          getUserdata({ sortField, sortOrder });
        } else {
          getUserdata('');
        }
        setLoading(true);
      }
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,
    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;
      const sortField = name; 
      const sortOrder = direction; 

      let searchQuery = searchEnable;
      let page_no = tableState.page;
      if (action === 'sort') {
        setSortEnable({ sortField, sortOrder });
        if (searchEnable) {
          getUserdata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getUserdata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
      setPage(tableState.page);
      if (action === 'changePage') {
        if (searchEnable) {
          getUserdata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getUserdata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
    },
  };
  const handlejobcreateform = () => {
    navigate('/master/paymentterm/create');
  };
  const handleEditRedirect = (e, id) => {
    navigate(`/master/paymentterm/update/${id}`);
  };
  const handleRowDelete = async (e, id) => {
    if (confirm('Are you sure want to delete?') === true) {
      setLoading(false);
      await authAxios.post(`${PRIVATE_ROUTE?.DELETE_PAYMENTTERM}${id}`);
      setOpen(null);
      setSelectedRow(null);
      setLoading(true);
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    }
  };
 
  useEffect(() => {
    if (rowsPerPage * page < count) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    } else {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
    }
    setLoading(true);
  }, [rowsPerPage]);

  return (
    <>
      <Grid sx={{ p: 4, pb: 0 }} direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Payment Term
          </Typography>
          <Button variant="contained" onClick={handlejobcreateform} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Payment Term
          </Button>
        </Stack>
        <Table>
          <MUIDataTable options={options} columns={columns} data={users} />
          
          {loading && (
            <div>
              <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>
          )}
        </Table>
      </Grid>
    </>
  );
}
